import { useMemo } from 'react';
import { useParams } from 'next/navigation';
import { APP_ROUTE_PATHS } from '@/configs/routes';

export default function useRegistryRoutes() {
  const { orgName } = useParams<{ orgName: string }>();

  const routes = useMemo(() => {
    const routes = Object.fromEntries(
      Object.entries(APP_ROUTE_PATHS).map(([key, value]) => [
        key,
        `/${orgName}/registry${value}`,
      ]),
    );
    routes.basePath = `/${orgName}/registry`;

    return routes;
  }, [orgName]) as { [K in keyof typeof APP_ROUTE_PATHS]: string } & {
    basePath: string;
  };

  return routes;
}
